import { LegalLayout, LegalSection } from "../components/Legal";

export default function NonDiscriminationPage() {
  return (
    <LegalLayout badge="Legal" title="Equal Opportunity & Non-Discrimination Statement" testid="non-discrimination-page">
      <LegalSection title="Our Commitment">
        <p>
          Cindyrella Cleaning LLC is committed to equal opportunity in every aspect of our
          business. We do not discriminate on the basis of race, color, religion, sex, sexual
          orientation, gender identity, national origin, age, disability, marital status, veteran
          status, or any other characteristic protected by federal, state, or local law.
        </p>
      </LegalSection>
      <LegalSection title="In Our Services">
        <p>
          We serve all clients — residential, commercial, and governmental — with the same
          professionalism, respect, and quality standards, without discrimination of any kind.
        </p>
      </LegalSection>
      <LegalSection title="In Our Employment Practices">
        <p>
          We are an equal opportunity employer. All employment decisions — including hiring,
          training, compensation, promotion, and discipline — are based on qualifications, merit,
          and business needs. We comply with applicable federal and Florida employment laws,
          including Title VII of the Civil Rights Act, the Americans with Disabilities Act (ADA),
          the Age Discrimination in Employment Act (ADEA), and the Florida Civil Rights Act.
        </p>
      </LegalSection>
      <LegalSection title="As a Government Contractor">
        <p>
          When performing work under public contracts, Cindyrella Cleaning LLC complies with all
          applicable non-discrimination and equal opportunity requirements, including any
          contract-specific provisions required by the contracting agency.
        </p>
      </LegalSection>
      <LegalSection title="Reporting Concerns">
        <p>
          Anyone who believes they have experienced or witnessed discrimination in connection with
          our services or employment practices is encouraged to contact us directly. All reports
          are taken seriously and handled with discretion.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
